var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.88533 15.1591C5.75059 14.1048 7.8574 13.5523 10 13.5556C12.2222 13.5556 14.3084 14.1378 16.1147 15.1591M12.6667 8.22222C12.6667 8.92947 12.3857 9.60774 11.8856 10.1078C11.3855 10.6079 10.7072 10.8889 10 10.8889C9.29276 10.8889 8.61448 10.6079 8.11438 10.1078C7.61428 9.60774 7.33333 8.92947 7.33333 8.22222C7.33333 7.51498 7.61428 6.8367 8.11438 6.3366C8.61448 5.83651 9.29276 5.55556 10 5.55556C10.7072 5.55556 11.3855 5.83651 11.8856 6.3366C12.3857 6.8367 12.6667 7.51498 12.6667 8.22222ZM18 10C18 11.0506 17.7931 12.0909 17.391 13.0615C16.989 14.0321 16.3997 14.914 15.6569 15.6569C14.914 16.3997 14.0321 16.989 13.0615 17.391C12.0909 17.7931 11.0506 18 10 18C8.94943 18 7.90914 17.7931 6.93853 17.391C5.96793 16.989 5.08601 16.3997 4.34315 15.6569C3.60028 14.914 3.011 14.0321 2.60896 13.0615C2.20693 12.0909 2 11.0506 2 10C2 7.87827 2.84285 5.84344 4.34315 4.34315C5.84344 2.84285 7.87827 2 10 2C12.1217 2 14.1566 2.84285 15.6569 4.34315C17.1571 5.84344 18 7.87827 18 10Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogin);
export default __webpack_public_path__ + "static/media/icon_login.06757a16ac12db6187274d13e1a1dcc5.svg";
export { ForwardRef as ReactComponent };